import CONSTANTS from "../CONSTANTS";

export const actionSendVerification = (data) => ({
  type: CONSTANTS.TOKEN_SEND_DATA,
  data,
});
